import React from 'react';

function RoomReportTotalItem2(props) {
    const { dayNames, days, dayOld1, dayOld2, getBackgroundColor,currentDate, handleMonthChange, type, room, handlePrev, handleNext ,option1, setOption1, dayMain} = props;
    
    function analysis(item, index) {
      let result;
      if(dayOld2[index] === "" && dayOld1[index] === "") return result = 0
      if(dayOld2[index] === "" && dayOld1[index] !== "") result = item.percent / dayOld1[index].percent;
      if(dayOld1[index] === "" && dayOld2[index] !== "") result = item.percent / dayOld2[index].percent;

      result = item.percent / ((dayOld2[index].percent + dayOld2[index].percent)/2);
      return Math.round(result*10000)/100;
    }

    return (<>
          {type === "predicted" &&  days.length > 0 &&  dayOld1.length > 0  &&  dayOld2.length > 0 && <div className="calendar-grid" style={{marginLeft:'90px', disdisplay: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '12px', fontSize: '1.2rem'}}>
                {dayNames.map((name, index) => (
                  (dayMain[index]=== "" && dayOld1[index] === "" && dayOld2[index] === "") ? "" : <div key={index} className="day-name" style={{background: (name ==="Sun" || name === "Sat") ? '#ff0000e0' : ""}}>{name}</div>
                ))}
          </div> }

         {days.length > 0 &&  dayOld1.length > 0  &&  dayOld2.length > 0 && <div className="calendar-grid"
             >
                {/* {dayNames.map((name, index) => (
                <div key={index} className="day-name" style={{background: (name ==="Sun" || name === "Sat") ? '#ff0000e0' : ""}}>{name}</div>
                ))} */}

                  <div className="day" style={{fontSize:'1.6rem', textAlign: 'center', alignItems:'center', margin: 'auto'}}>{type === "predicted" ? "Predicted" : currentDate.getFullYear() - Number(type) + 1}</div>
                {days.length > 0 &&  days.map((item, index) =>{
                   if(item) {
                       return <React.Fragment key={index}>
                        <div
                        className={"day " + (index === props.active ? "active" : "")}
                      //  onClick={() => props.setActive(index)}
                        onMouseEnter={() => props.setActive(index)}
                      // data-tip={"React-tooltip"+type+"d"+index}
                        // data-tip
                        // data-for={"React-tooltip"+type+"d"+index}
                        // style={{ backgroundColor: getBackgroundColor(item.percent ? item.percent :Math.round((item.guestNumber / room)*10000)/100) }}
                        style={{ backgroundColor: getBackgroundColor(item.percent) }}

                        >
                        <div className="day-top">
                            <div className="day-number">{item === "" ? "" : item.date.slice(8,10)}</div>
                        </div>
                        {/* <div className="day-percent">{item.percent ? (item.percent === 0 ? 0 : item.percent) 
                            :item.guestNumber === 0 ? 0 : Math.round((item.guestNumber / room)*10000)/100}%</div> */}

                        <div className="day-percent">{type ==="predicted" ? analysis(item, index) : item.percent}%</div>

                        {/* <div className="day-percent">{Math.round((dayOld[index].guestNumber / room)*10000)/100}%</div> */}

                        {/* <ReactTooltip place="top" type="dark" effect="float" id={"React-tooltip"+type+"d"+index}>
                            <div>MemberShip: {item.memberShip}</div>
                            <div>OTA: {item.OTA}</div>
                            <div>Late: {item.late}</div>
                            <div>Total Price: {item.totalPrice.toLocaleString()}$</div>

                        </ReactTooltip> */}
                        </div>
                      {type ==="predicted" && !option1 && dayOld1.length > 0  &&  dayOld2.length > 0  &&
                          <div className="mb-3">
                              <div style={{color: item.percent - dayOld1[index].percent > 0 ? "green": "red", fontWeight:'600'}}>{currentDate.getFullYear() - 1}: {Math.round((item.percent - dayOld1[index].percent)*100)/100}%</div>
                              <div style={{color: item.percent - dayOld2[index].percent > 0 ? "green": "red", fontWeight:'600'}}>{currentDate.getFullYear() - 2}: {Math.round((item.percent - dayOld2[index].percent)*100)/100}%</div>  
                          </div>}
                      </React.Fragment>
                    } else {
                      // if(type === "predicted" ) {
                      //   console.log("dayMain[index] index = "+index, dayMain[index])
                      //   console.log("dayOld1[index] index = "+index, dayOld1[index])
                      //   console.log("dayOld2[index] index = "+index, dayOld2[index])
                      // }

                      if(dayMain[index]=== "" && dayOld1[index] === "" && dayOld2[index] === "") {
                        
                      } else {
                          if(!option1) return <div key={index} className="day empty"></div> 
                      }
                    }
                    
                })}
          </div> }
      </>)
}

export default RoomReportTotalItem2;
